import * as urls from '../api/urls'
import { identity } from '../utils/mainUtils'
import * as schema from './categorySchema'

import bookingCategories from './parsers/bookingParsers/bookingCategories'
import bookingOrganizations from './parsers/bookingParsers/bookingOrganizations'
import bookingRates from './parsers/bookingParsers/bookingRates'

import dobovoApartments from './parsers/dobovoParsers/dobovoApartments'
import dobovoOrganizations from './parsers/dobovoParsers/dobovoOrganizations'

import easymsCategories from './parsers/easymsParsers/easymsCategories'
import easymsOrganizations from './parsers/easymsParsers/easymsOrganizations'
import easymsRates from './parsers/easymsParsers/easymsRates'

import expediaCategories from './parsers/expediaParsers/expediaCategories'
import expediaOrganizations from './parsers/expediaParsers/expediaOrganizations'
import expediaRates from './parsers/expediaParsers/expediaRates'

import h24Categories from './parsers/h24Parsers/h24Categories'
import h24Organizations from './parsers/h24Parsers/h24Organizations'
import h24Rates from './parsers/h24Parsers/h24Rates'

import hwCategories from './parsers/hostelWorldParsers/hwCategories'
import hwOrganizations from './parsers/hostelWorldParsers/hwOrganizations'
import hwRates from './parsers/hostelWorldParsers/hwRates'

import importedApartments from './parsers/importedApartments'
import importedCategories from './parsers/importedCategories'
import importedRates from './parsers/importedRates'

import omnitecOrganizationsFind from './parsers/omnitecParsers/omnitecOrganizations'

const parsers = {
    [urls.hwCategories]: hwCategories,
    [urls.hwOrganizations]: hwOrganizations,
    [urls.hwRates]: hwRates,
    [urls.reloadCategoriesFromHw]: importedCategories,

    [urls.bookingCategories]: bookingCategories,
    [urls.bookingOrganizations]: bookingOrganizations,
    [urls.bookingRates]: bookingRates,
    [urls.reloadCategoriesFromBooking]: importedCategories,
    [urls.reloadRatesFromBooking]: importedRates,

    [urls.h24Categories]: h24Categories,
    [urls.h24Organizations]: h24Organizations,
    [urls.h24Rates]: h24Rates,
    [urls.reloadCategoriesFromH24]: importedCategories,
    [urls.reloadRatesFromH24]: importedRates,

    [urls.dobovoApartments]: dobovoApartments,
    [urls.dobovoOrganizations]: dobovoOrganizations,
    [urls.reloadApartmentsFromDobovo]: importedApartments,

    [urls.expediaCategories]: expediaCategories,
    [urls.expediaOrganizations]: expediaOrganizations,
    [urls.expediaRates]: expediaRates,
    [urls.reloadCategoriesFromExpedia]: importedCategories,
    [urls.reloadRatesFromExpedia]: importedRates,

    [urls.easymsOrganizations]: easymsOrganizations,
    [urls.easymsCategories]: easymsCategories,
    [urls.easymsRates]: easymsRates,

    [urls.omnitecOrganizationsFind]: omnitecOrganizationsFind
}

const get = map => url => map[url] || identity

export const getParser = get(parsers)

export { schema }



// WEBPACK FOOTER //
// ./src/adapters/index.js